import React, {useCallback, useEffect, useState, useRef} from "react";
import axios from "axios";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import PdfPng from '../../Assets/Pdf.png';
import { Button } from "react-bootstrap";
import { OAuthApiStartPolling, OAuthApiStopPolling } from "../../ExternalApi/OAuthApi"
import { ConfigurationApiForward } from "../../ExternalApi/ConfigurationApi"
import IntegrationWizardDots from "../IntegrationWizard/IntegrationWizardDots"

const DatasourceLawVu = (props) => {
    
    const [mRepainter, SetRepainter] = useState(false); 
    const [mWaitingForState, SetWaitingForState] = useState("")
    const [mError, SetError] = useState("") 
    const [mOAuthWindow, SetOAuthWindow] = useState(null) 

    const cProductionBaseUrl = 'https://go.lawvu.com'
    const cProductionApiUrl = 'https://api.lawvu.com'
    const cProductionClientId = ''
    const cProductionClientSecret = ''
    const cSandboxBaseUrl = 'https://demo.lawvu.com'
    const cSandboxApiUrl = 'https://api-sandbox.lawvu.com'
    const cSandboxClientId = 'sandbox-1687'
    const cSandboxClientSecret = '0df39c7c-a4f7-4119-a0fe-141de1762e96'
    const cRedirectUrl = 'https://auth.cloudcti.nl/webapi/oauth2'

    useEffect(() => {
        props.IntegrationSettings.DatasourceSettings.SandboxEnvironment = true
        SetReady()
      }, []); 

    const UpdateDatasourceSetting = (aNewValue, aIdentifier) =>
    {
        SetRepainter(!mRepainter)
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aNewValue

        SetReady()
    }

    const SetReady = () => 
    {
        props.OnSetReady(props.IntegrationSettings.DatasourceSettings.RefreshToken)
    }

    async function GetTokens(aAuthorizationCode) 
    {
        const TokenUrl = (props.IntegrationSettings.DatasourceSettings.SandboxEnvironment ? cSandboxApiUrl : cProductionApiUrl) + '/account-apis/v1/auth/token'
        const Body = "grant_type=authorization_code" +
            "&code=" + aAuthorizationCode +
            "&client_id=" + (props.IntegrationSettings.DatasourceSettings.SandboxEnvironment ? cSandboxClientId : cProductionClientId) +
            "&client_secret=" + (props.IntegrationSettings.DatasourceSettings.SandboxEnvironment ? cSandboxClientSecret : cProductionClientSecret) +
            "&redirect_uri=" + cRedirectUrl

        let Result = await ConfigurationApiForward(
            props.SecurityToken, 
            TokenUrl, 
            "POST", 
            Body, 
            "application/json", 
            "application/x-www-form-urlencoded")
        if (Result != null)
        {
            UpdateDatasourceSetting(Result.data.access_token, "AccessToken")
            UpdateDatasourceSetting(Result.data.refresh_token, "RefreshToken")
        }
        else
        {
            SetError("Failed to retrieve tokens")
        }

        SetWaitingForState("")
    }

    const OAuthPollResult = (aResult, aValue) =>
    {
        if (aResult)
        {
            console.log("OAuthPollResult success: " + JSON.stringify(aValue))
            if (aValue.Code)
            {
                GetTokens(aValue.Code)
            }
            else
            {
                SetError("Failed to authenticate. No authorizationcode found")  
            }
        }
        else
        {
            console.log("OAuthPollResult error: " + JSON.stringify(aValue))  
            SetError("Failed to authenticate")          
        }
    }

    const RandomState = () => 
    {
        let Result = "client2020WEB"

        var characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        for ( var i = 0; i < 27; i++ ) 
        {
            Result += characters.charAt(Math.floor(Math.random() * characters.length))
        }
        
        return Result
    }

    const StartOAuth = () =>
    {
        const State = RandomState()

        const OAuthUrl = (props.IntegrationSettings.DatasourceSettings.SandboxEnvironment ? cSandboxBaseUrl : cProductionBaseUrl) + '/#/authorize' +
            '?response_type=code' +
            '&client_id=' + (props.IntegrationSettings.DatasourceSettings.SandboxEnvironment ? cSandboxClientId : cProductionClientId)  +
            '&redirect_uri=' + cRedirectUrl +
            '&state=' + State;
        const OAuthWindow = window.open(OAuthUrl, "_blank", 'popup=yes,titlebar=0,left=' + ((screen.availWidth - 750)/2)  + ',top=' + ((screen.availHeight - 750)/2)  + ',width=750,height=750')
        SetOAuthWindow(OAuthWindow)
        OAuthApiStartPolling(State, OAuthPollResult, OAuthWindow)

        SetWaitingForState(State)
    }

    const StopOAuth = () =>
    {
        try 
        { 
            if (mOAuthWindow !== null)
            {
                mOAuthWindow.close() 
                SetOAuthWindow(null)
            }
        } 
        catch {}

        OAuthApiStopPolling()

        SetWaitingForState("")
    }
    
    const BrandingId = sessionStorage.getItem("BrandingId")

    const Body = props.IntegrationSettings.DatasourceSettings.RefreshToken ?
        //Authorization OK
        <div className="scriptitembody">
            {Translate("$Application connection token received succesfully").replace("$Application","LawVu")}
        </div> :
        (mError ?
            //Authorization failed. Show error and connect button
            <div className="scriptitembody">
                <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button><br/>
                <div>{mError}</div>
            </div> :
            (mWaitingForState ?
                //Waiting for authorization. Show dot counter and cancel button
                <div className="scriptitembody">
                    <Button variant="danger" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StopOAuth()} type="submit">{Translate("Cancel")}</Button><br/><br/>
                    <div>{Translate("Waiting for OAUTH verification")}<IntegrationWizardDots/></div>
                </div> :
                //Not authenticating. Show connect button
                <div className="scriptitembody">
                    <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button>
                </div>
            )
        )

    return (
        <span>
            {Body}
            <table cellPadding="2" disabled={true}> 
            <tbody>
                <tr>
                    <td width="30"> <span className="checkbox-wrapper-13" ><input type="checkbox" checked={true} onChange={evt => UpdateDatasourceSetting(evt.target.checked, "SandboxEnvironment")}/></span> </td>
                    <td width="*"><span style={{ color: "gray"}}>{Translate("Sandbox environment")}</span></td>
                </tr>
            </tbody>
            </table>
        </span>
    )
}

DatasourceLawVu.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceLawVu